/**
 * @author chuzhixin 1204505056@qq.com
 * @description 登录、获取用户信息、退出登录、清除accessToken逻辑，不建议修改
 */
import { getUserInfoNew, login, v2login, getConfig } from '@/api/user'
import {
  getAccessToken,
  removeAccessToken,
  setAccessToken,
  logout as logoutFn,
  setLocalRoutes
} from '@/utils/auth'
import { title, tokenName, refreshToken } from '@/config'
import { message, notification } from 'ant-design-vue'

const state = () => ({
  accessToken: getAccessToken(),
  username: '',  // 用户名
  avatar: '',
  config: '',
  userInfo: '',
  account: '',  // 账号
  permissionList: [],
  isDashboard: false,
  depart: {
    visit_area: ''
  }
})
const getters = {
  accessToken: (state) => state.accessToken,
  username: (state) => state.username,
  account: (state) => state.account,  // 账号
  permissionList: (state) => state.permissionList,
  avatar: (state) => state.avatar,
  config: (state) => state.config,
  isDashboard: (state) => state.isDashboard,
  depart: (state) => state.depart,
}
const mutations = {
  /**
   * @author chuzhixin 1204505056@qq.com
   * @description 设置accessToken
   * @param {*} state
   * @param {*} accessToken
   */
  setAccessToken(state, accessToken) {
    state.accessToken = accessToken
    setAccessToken(accessToken)
  },
  /**
   * @author chuzhixin 1204505056@qq.com
   * @description 设置用户名
   * @param {*} state
   * @param {*} username
   */
  setUsername(state, username) {
    state.username = username
  },
  setDashboard(state, auth) {
    state.isDashboard = auth
  },
  setUserInfo(state, info) {
    state.userInfo = info
  },
  setAccount(state, account) {
    state.account = account
  },
  setDepart(state, depart) {
    state.depart = depart
  },
  setPermissionList(state, permiss) {
    state.permissionList = permiss
  },
  /**
   * @author chuzhixin 1204505056@qq.com
   * @description 设置头像
   * @param {*} state
   * @param {*} avatar
   */
  setAvatar(state, avatar) {
    state.avatar = avatar
  },
  /**
   * @author lwx
   * @description 设置配置
   * @param {*} state
   * @param {*} avatar
   */
  setConfig(state, config) {
    state.config = config
  },
}
const actions = {
  /**
   * @author chuzhixin 1204505056@qq.com
   * @description 登录拦截放行时，设置虚拟角色
   * @param {*} { commit, dispatch }
   */
  setVirtualRoles({ commit, dispatch }) {
    dispatch('acl/setFull', true, { root: true })
    commit('setAvatar', 'https://i.gtimg.cn/club/item/face/img/2/15922_100.gif')
    commit('setUsername', 'admin(未开启登录拦截)')
  },
  /**
   * @author chuzhixin 1204505056@qq.com
   * @description 登录
   * @param {*} { commit }
   * @param {*} userInfo
   */
  async login({ commit }, userInfo) {
    const res = await login(userInfo)
    const { data } = res
    const accessToken = data[tokenName]
    if (refreshToken) {
      localStorage.setItem('exp', data.exp)
    }
    if (accessToken) {
      commit('setAccessToken', accessToken)

      const hour = new Date().getHours()
      const thisTime =
        hour < 8
          ? '早上好'
          : hour <= 11
          ? '上午好'
          : hour <= 13
          ? '中午好'
          : hour < 18
          ? '下午好'
          : '晚上好'
      notification.open({
        message: `欢迎登录${title}`,
        description: `${thisTime}！`,
      })
    } else {
      message.error(`登录接口异常，未正确返回${tokenName}...`)
    }

    return res
  },
  async v2login({ commit }, userInfo) {
    const res = await v2login(userInfo)
    const { data } = res
    const accessToken = data[tokenName]
    if (refreshToken) {
      localStorage.setItem('exp', data.exp)
    }
    if (accessToken) {
      commit('setAccessToken', accessToken)

      const hour = new Date().getHours()
      const thisTime =
        hour < 8
          ? '早上好'
          : hour <= 11
          ? '上午好'
          : hour <= 13
          ? '中午好'
          : hour < 18
          ? '下午好'
          : '晚上好'
      notification.open({
        message: `欢迎登录${title}`,
        description: `${thisTime}！`,
      })
    } else {
      message.error(`登录接口异常，未正确返回${tokenName}...`)
    }

    return res
  },
  /**
   * @author lwx
   * @description 获取配置
   */
  async getConfig({ commit }) {
    const { data } = await getConfig()
    if (data) {
      commit('setConfig', data)
    } else {
      message.error(`获取系统配置失败，请联系管理员`)
    }
  },
  /**
   * @author chuzhixin 1204505056@qq.com
   * @description 获取用户信息接口 这个接口非常非常重要，如果没有明确底层前逻辑禁止修改此方法，错误的修改可能造成整个框架无法正常使用
   * @param {*} { commit, dispatch, state }
   * @returns
   */
  async getUserInfo({ commit, dispatch }) {
    const { data } = await getUserInfoNew()
    if (!data) {
      message.error(`验证失败，请重新登录...`)
      return false
    }
    let { user_name, account, depart, roleList, permissionList } = data

    if (user_name && roleList && Array.isArray(roleList)) {
      dispatch(
        'acl/setRole',
        roleList.map((item) => item.code),
        { root: true }
      )
      dispatch('acl/setAbility', ['READ', 'WRITE', 'DELETE'], { root: true })

      const routes = permissionList.map((item) => item.code)
      // routes.push('notice')  // 默认添加通知页面路由
      setLocalRoutes(routes)
      dispatch('acl/setRoutes', routes, { root: true })
      const isDashboard = routes.includes('dashboard');
      commit('setDashboard', isDashboard)
      commit('setUsername', user_name)
      commit('setAccount', account)
      commit('setDepart', depart)
      commit('setUserInfo', data)
      commit('setPermissionList', permissionList)
    } else {
      message.error('用户信息接口异常')
    }
  },
  // async getUserInfo({ commit, dispatch, state }) {
  //   const { data } = await getUserInfo(state.accessToken)
  //   if (!data) {
  //     message.error(`验证失败，请重新登录...`)
  //     return false
  //   }
  //   let { username, avatar, roles, ability } = data
  //   if (username && roles && Array.isArray(roles)) {
  //     dispatch('acl/setRole', roles, { root: true })
  //     if (ability && ability.length > 0)
  //       dispatch('acl/setAbility', ability, { root: true })
  //     commit('setUsername', username)
  //     commit('setAvatar', avatar)
  //   } else {
  //     message.error('用户信息接口异常')
  //   }
  // },

  /**
   * @author chuzhixin 1204505056@qq.com
   * @description 退出登录
   * @param {*} { dispatch }
   */
  async logout({ dispatch }) {
    logoutFn()
    // await logout(state.accessToken)
    // await dispatch('resetAll')
  },
  /**
   * @author chuzhixin 1204505056@qq.com
   * @description 重置accessToken、roles、ability、router等
   * @param {*} { commit, dispatch }
   */
  async resetAll({ dispatch }) {
    await dispatch('setAccessToken', '')
    await dispatch('acl/setFull', false, { root: true })
    await dispatch('acl/setRole', [], { root: true })
    await dispatch('acl/setAbility', [], { root: true })
    removeAccessToken()
  },
  /**
   * @author chuzhixin 1204505056@qq.com
   * @description 设置token
   */
  setAccessToken({ commit }, accessToken) {
    commit('setAccessToken', accessToken)
  },
}
export default { state, getters, mutations, actions }
